import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Masthead, { MastheadLink, MastheadTitle } from "@amzn/meridian/esm/components/masthead";
import Theme from "@amzn/meridian/esm/components/theme";
import { TABS } from "../../constants";
import aimsTheme from "../../styles/meridian-theme-aims.json";
import { THEME_COLOR } from "../../styles/colors";

const SETTINGS_LABEL = "Settings";
const FEEDBACK_LABEL = "Feedback";

const AimsMasthead = ({ selectedTab, setSelectedTab, isVerboseSummariesEnabled }) => {
  const onClickLink = (id) => () => {
    setSelectedTab(id); // Updates state in Home.jsx
  };

  const settingsTab = isVerboseSummariesEnabled ? TABS.SETTINGS : TABS.HELP;
  const settingsLabel = isVerboseSummariesEnabled ? SETTINGS_LABEL : FEEDBACK_LABEL;

  return (
    <Theme palette={aimsTheme} tokens={{ mastheadLinkIndicatorColor: THEME_COLOR.TEAL_GREEN }}>
      <Column>
        <Masthead size="large">
          <MastheadTitle>
            <Box spacingInset="none" width="34px"></Box>
          </MastheadTitle>
          <MastheadLink selected={selectedTab === TABS.MAIN} onClick={onClickLink(TABS.MAIN)}>
            Main
          </MastheadLink>
          <MastheadLink selected={selectedTab === TABS.SUMMARIES} onClick={onClickLink(TABS.SUMMARIES)}>
            Summaries
          </MastheadLink>
          <MastheadLink selected={selectedTab === settingsTab} onClick={onClickLink(settingsTab)}>
            {settingsLabel}
          </MastheadLink>
        </Masthead>
      </Column>
    </Theme>
  );
};

export default AimsMasthead;
